import ar from './locales/ar.json'
import enGb from './locales/en-GB.json'
import enUs from './locales/en-US.json'
import en from './locales/en.json'
import es from './locales/es.json'
import fa from './locales/fa.json'
import fr from './locales/fr.json'
import he from './locales/he.json'
import ja from './locales/ja.json'
import ps from './locales/ps.json'

// Documentation: https://i18n.nuxtjs.org/
export default defineI18nConfig(() => {
  return {
    legacy: false,
    locale: 'en-GB',
    messages: {
      'en-GB': enGb,
      'en-US': enUs,
      en,
      es,
      fr,
      //   ja,
      //   ar,
      //   he,
      //   fa,
      ps,
    },
  }
})
